import angular, { ISCEService } from 'angular';
import { AnnouncementsProps, AnnouncementsVM } from './announcements.types';

export class AnnouncementsService {
  static $inject = ['$sce'];

  vm: AnnouncementsVM = {
    model: { announcements: [] },
  };

  constructor(private $sce: ISCEService) {}

  addAnnouncement(props: AnnouncementsProps) {
    const announcement: AnnouncementsProps = {
      type: props.type || 'info',
      message: props.message,
      messageParsed: this.$sce.trustAsHtml(props.message),
      dismissible: props.dismissible ?? true,
      dismissed: false,
    };
    this.vm.model.announcements.push(announcement);
  }

  getAnnouncements(): AnnouncementsProps[] {
    return this.vm.model.announcements;
  }

  dismissAnnouncement(announcement: AnnouncementsProps) {
    announcement.dismissed = true;
  }

  reset() {
    this.vm.model.announcements = [];
  }
}

export const AnnouncementsServiceModule = angular
  .module('acme.common.service.announcements', [])
  .service('AnnouncementsService', AnnouncementsService).name;
